import { Analytics } from '@vercel/analytics/react';
import { ReactNode } from 'react';
import { useBreakpoints, Layout as BaseLayout } from '@silo/ui';
import { MobileNav } from '../../nav/mobile-nav';
import { DesktopNav } from '../../nav/desktop-nav';

interface LayoutProps {
  children?: ReactNode;
}

export function Layout({ children }: LayoutProps): JSX.Element {
  const { md } = useBreakpoints();

  return (
    <div className="flex justify-center">
      <BaseLayout className="flex flex-col gap-10 items-stretch w-full md:gap-8">
        <div>{md ? <DesktopNav /> : <MobileNav />}</div>

        <Main>{children}</Main>
      </BaseLayout>
    </div>
  );
}

interface MainProps {
  children?: ReactNode;
}

export function Main({ children }: MainProps): JSX.Element {
  return (
    <main className="flex flex-col" style={{ height: 'max-content' }}>
      {children}

      <Analytics />
    </main>
  );
}

export default Layout;
